import { Component, AfterViewInit, ViewChild, NgZone } from '@angular/core';
//import { MdePopoverTrigger } from '@material-extended/mde';
import { ForTooltipComponent } from '../tooltip/for-tooltip.component';
import * as Highcharts from 'highcharts';
import { DataService } from '../../services/data.service';
import { AppService } from '../../services/app.service';
import { PaginatorService } from '../../services/paginator.service';
import { LoadingService } from '../../services/loading.service';
import { BehaviorSubject, } from 'rxjs';
import { Router } from '@angular/router';


@Component({
  selector: 'app-runPatientDeletion',
  templateUrl: './runPatientDeletion.component.html',
})
export class RunPatientDeletionComponent {
  public allRuns: any;
  public allPatients: any;
  public query: string;

  constructor(private router: Router, private dataService: DataService, public appService: AppService, public paginatorService: PaginatorService) {
    //this.dataService.getall('Home/GetAllRunsForCenter').subscribe(
    //  (res: any) => {
    //    //console.log(res.data);
    //    this.allRuns = res.data;
    //  },
    //  err => {
    //    console.log(err);
    //  }
    //);

    this.getAllPatientsForCenter();
  }

  ngOnInit() {
    this.appService.Run = null;
    this.appService.Patient = null;
  }

  getAllPatientsForCenter() {
    this.dataService.getall('Home/GetAllPatientsForCenter').subscribe(
      (res: any) => {
        console.log(res.data);
        this.allPatients = res.data;
      },
      err => {
        console.log(err);
      }
    );
  }

  deleteHospitalization(hospitalizationId: string, patientId: string) {
    var deleteHospitalization = true;

    alert("If you delete hospitalization, runs for this hospitalization will also be deleted.");

    var selectedPatient = this.appService.lodashFindBy(this.allPatients, 'PatientId', patientId);
    if (selectedPatient.Hospitalizations.length == 1) {
      deleteHospitalization = confirm("This is the last hospitalization for patient. If you delete this hospitalization, patient will also be deleted. Please confirm.");
    }

    if (deleteHospitalization == true) {
      this.dataService.delete('Hospitalizations/DeleteHospitalization', 'HospitalizationId', hospitalizationId)?.subscribe(
        (res: any) => {
          this.getAllPatientsForCenter();
          this.query = "";
        },
        err => {
          console.log(err);
        }
      );
    }
  }

  deleteRun(runId: string, hospitalizationId: string, patientId: string) {
    var deleteRun = true;
    var selectedPatient = this.appService.lodashFindBy(this.allPatients, 'PatientId', patientId);

    var selectedHospitalization = this.appService.lodashFindBy(selectedPatient.Hospitalizations, 'HospitalizationId', hospitalizationId);

    if (selectedHospitalization.Runs.length == 1 && selectedPatient.Hospitalizations.length == 1) {
      deleteRun = confirm("This is the last run for hospitalization and last hospitalization for patient. If you delete this run, hospitalization and patient will also be deleted. Please confirm.");
    } else if (selectedHospitalization.Runs.length == 1) {//patient has more than 1 hospitalization
      deleteRun = confirm("This is the last run for hospitalization. If you delete this run, hospitalization will also be deleted. Please confirm.");
    }

    if (deleteRun == true) {
      this.dataService.delete('Runs/DeleteRun', 'RunId', runId)?.subscribe(
        (res: any) => {
          //console.log(runId);
          //this.appService.lodashRemoveBy(this.allRuns, 'RunId', runId);
          //console.log(this.allRuns);
          this.getAllPatientsForCenter();
          this.query = "";
        },
        err => {
          console.log(err);
        }
      );
    }

  }
  
  deletePatient(patientId: string) {

    this.dataService.delete('Patients/DeletePatient', 'PatientId', patientId)?.subscribe(
      (res: any) => {
        //this.appService.lodashRemoveBy(this.allRuns, 'PatientId', patientId);
        ////console.log(this.allRuns);
        this.getAllPatientsForCenter();
        this.query = "";
      },
      err => {
        console.log(err);
      }
    );
  }
  
}
